<template>
  <div class="doc-upload-wrapper">
    <banner-table></banner-table>
  </div>
</template>

<script>
import BannerTable from '../components/dokumentyupload/DokumentyUploadTable.vue';

export default {
  components: {
    BannerTable,
  },
  data() {
    return {};
  },
};
</script>
<style lang="sass">
  .doc-upload-wrapper 
    @media (max-width: 959px) 
      padding-bottom: 86px
</style>
